import {
  AppBar,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  useMediaQuery,
  Divider,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useContext } from 'react';
import { getServiceItems, redirectionData } from '../../shared/helper';
import AlertIcon from '@mui/icons-material/FiberManualRecord';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import HelpIcon from '@mui/icons-material/Help';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AvatarImg from './AvatarImg';
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_MOBILE,
  FIXED_DASHBOARD_SERVICES,
  NOTIFICATION_OBJECT,
  NOTIFICATION_CATEGORY,
  NOTIFICATION_ALERT_MENU_ITEMS,
} from '../../shared/constants';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useEffect } from 'react';
import mphLogo from '../../assests/mphLogo.svg';
import GlobalContext from '../../context/globalContext';
import ApplicationContext from '../../context/applicationContext';
import useAuth from '../../services/hooks/useAuth';
import { IMAGE_ALTERNATE_TEXT } from '../../shared/Strings';

const drawerWidth = DRAWER_WIDTH;
const drawerWidthMobile = DRAWER_WIDTH_MOBILE;

const WithNavBar = ({ window }) => {
  const { carousel } = useContext(GlobalContext);
  const { menuItems, userInfo } = useContext(ApplicationContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const params = useLocation();
  const [open, setOpen] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'), {
    noSsr: true,
  });
  const opendropdown = Boolean(anchorEl);
  const openNotificationPopup = Boolean(notificationAnchorEl);
  const navigate = useNavigate();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleBellIconClick = event => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleCloseNotificationPopup = () => {
    setNotificationAnchorEl(null);
  };

  const handleCloseAndNavigate = item => {
    if (item.route === 'financial/bills') {
      navigate(item.route);
    } else {
      navigate(item.route, { state: redirectionData(item.route) });
    }
    setNotificationAnchorEl(null);
  };

  const { logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCollapse = val => {
    setOpen(prvState => ({
      [val]: !prvState[val],
    }));
    if (isSmallScreen) {
      handleDrawerToggle();
    }
  };

  const getInitialPathFromPathName = pathname => {
    return `/${pathname.split('/')[1]}`;
  };

  const getSecondaryPathFromPathName = pathname => {
    return `/${pathname.split('/')[2]}`;
  };

  useEffect(() => {
    for (const item in menuItems) {
      if (
        menuItems[item].route === getInitialPathFromPathName(params.pathname)
      ) {
        setOpen({ [item]: true });
      }
    }
  }, [params.pathname, menuItems]);

  useEffect(() => {
    if (!isSmallScreen) {
      setMobileOpen(false);
    }
  }, [isSmallScreen]);

  const activeRoute = route => {
    return getInitialPathFromPathName(params.pathname) === route;
  };

  const secondaryRoute = route => {
    return getSecondaryPathFromPathName(params.pathname) === route;
  };

  const notificationMenuItem = item => {
    return (
      <Box sx={{ display: 'flex' }}>
        {item}
        <div
          style={{
            height: '6px',
            width: '6px',
            backgroundColor: 'red',
            borderRadius: '50%',
            marginLeft: '3px',
          }}></div>
      </Box>
    );
  };

  const drawer = menuItems ? (
    <Box sx={{ pb: '140px' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 80,
          mt: 2,
        }}>
        <Box
          component="img"
          sx={{
            height: 120,
            width: { sm: 250, xs: 200 },
          }}
          alt={IMAGE_ALTERNATE_TEXT.AFFILIATE_LOGO}
          src={carousel.logo}
        />
      </Box>
      <List
        sx={{
          '&& .Mui-selected, && .Mui-selected:hover': {
            bgcolor: 'transparent',
          },
          top: 20,
        }}
        // onClick={handleDrawerToggle}
      >
        {Object.keys(menuItems).map((text, index) => (
          <React.Fragment key={index}>
            <ListItem
              button
              onClick={() => handleCollapse(text)}
              key={index}
              sx={{
                m: 1,
                '&:hover': {
                  background: 'transparent',
                },
              }}
              component={Link}
              to={menuItems[text].route}>
              <ListItemIcon sx={{ pl: 2 }}>
                <img
                  src={
                    activeRoute(menuItems[text].route)
                      ? menuItems[text].icon
                      : menuItems[text].inactiveIcon
                  }
                  alt="icon"
                />
              </ListItemIcon>
              <ListItemText
                primary={text}
                primaryTypographyProps={{
                  variant: activeRoute(menuItems[text].route)
                    ? 'navSelected'
                    : 'nav',
                }}
              />
              {menuItems[text].subItems.length > 0 ? (
                open[text] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItem>
            {menuItems[text].subItems.map(subItem => (
              <Collapse
                in={open[text]}
                timeout="auto"
                unmountOnExit
                key={subItem.id}>
                <List
                  component="div"
                  disablePadding
                  sx={{
                    '&& .Mui-selected, && .Mui-selected:hover': {
                      bgcolor: '#4B4B4B',
                    },
                    ml: 1,
                  }}>
                  <ListItem
                    button
                    key={subItem.id}
                    sx={{
                      '&:hover': {
                        background: 'transparent',
                      },
                    }}
                    component={Link}
                    to={subItem.route}
                    onClick={() => {
                      if (isSmallScreen) {
                        handleDrawerToggle();
                      }
                    }}>
                    <ListItemText
                      inset
                      primary={
                        NOTIFICATION_ALERT_MENU_ITEMS.includes(subItem.category)
                          ? notificationMenuItem(subItem.category)
                          : subItem.category
                      }
                      primaryTypographyProps={{
                        variant: secondaryRoute(
                          `/${subItem.route.split('/')[2]}`
                        )
                          ? 'navSelected'
                          : 'nav',
                      }}
                    />
                  </ListItem>
                </List>
              </Collapse>
            ))}
          </React.Fragment>
        ))}
      </List>
      <Box
        sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          height: 110,
          width: { xs: drawerWidthMobile, sm: drawerWidth },
          background: '#ffffff',
          borderRight: '0.01rem solid rgb(0, 0, 0, .12)',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}>
        <Typography variant="nav" sx={{ mt: 2 }}>
          Powered by
        </Typography>
        <Box
          component="img"
          sx={{
            height: 62,
            width: '70%',
          }}
          alt="Affiliate Logo."
          src={mphLogo}
        />
      </Box>
    </Box>
  ) : null;

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${Number(drawerWidth) - 1}px)` },
          ml: { sm: `${Number(drawerWidth) - 1}px` },
          height: 80,
          bgcolor: '#fff',
          borderBottom: '0.01rem solid rgb(0, 0, 0, .12)',
          zIndex: { sm: 1300 },
        }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              color: '#4B4B4B',
              mt: '13px',
              mr: 2,
              display: { sm: 'none' },
            }}>
            <MenuIcon />
          </IconButton>
          <HelpIcon
            sx={{
              ml: 'auto',
              mr: '40px',
              mt: '10px',
              width: '36px',
              height: '28px',
              color: '#4B4B4B',
            }}
          />
          <NotificationsIcon
            sx={{
              mr: '40px',
              mt: '10px',
              width: '36px',
              height: '28px',
              color: '#4B4B4B',
              cursor: 'pointer',
            }}
            aria-controls={
              openNotificationPopup ? 'notification-menu' : undefined
            }
            aria-haspopup="true"
            aria-expands={openNotificationPopup ? 'true' : undefined}
            onClick={handleBellIconClick}
          />
          {userInfo && <AvatarImg userName={userInfo?.name} />}
          <ExpandMore
            sx={{ color: '#4B4B4B', mt: '10px', mr: '12px', cursor: 'pointer' }}
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          />
          <Box>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              sx={{ mt: '15px' }}
              open={opendropdown}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}>
              <MenuItem
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  maxWidth: '120px',
                  pl: '10px',
                  m: '8px 8px',
                }}
                onClick={handleLogout}>
                Logout
              </MenuItem>
            </Menu>
          </Box>
          <Box>
            <Menu
              id="notification-menu"
              anchorEl={notificationAnchorEl}
              sx={{ mt: '15px' }}
              open={openNotificationPopup}
              onClose={handleCloseNotificationPopup}>
              <MenuItem
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  fontSize: '16px',
                }}>
                Notifications
              </MenuItem>
              <Divider />
              {getServiceItems(menuItems, FIXED_DASHBOARD_SERVICES).map(
                (item, i, arr) => (
                  <Box
                    key={item.category}
                    // component='button'
                    // to={item.route}
                    onClick={() => handleCloseAndNavigate(item)}
                    sx={{ textDecoration: 'none' }}>
                    <MenuItem>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        <Box
                          component="img"
                          sx={{
                            height: '25px',
                            width: '25px',
                            marginRight: '20px',
                          }}
                          src={item.icon}
                          alt={item.category}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography>
                            {NOTIFICATION_OBJECT[item.category]}
                          </Typography>
                          <Typography
                            sx={{
                              color: 'grey',
                              fontSize: '12px',
                              fontWeight: 500,
                            }}>
                            {NOTIFICATION_CATEGORY[item.category]}
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                    {arr.length - 1 !== i && <Divider />}
                  </Box>
                )
              )}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidthMobile,
            },
          }}>
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open>
          {drawer}
        </Drawer>
      </Box>
      <Outlet />
    </Box>
  );
};

export default WithNavBar;
